import React from "react";
import { Flex, Text, Box } from "@fluentui/react-northstar";
import { InfoIcon } from "@fluentui/react-icons-northstar";

// Advisor Tip Component - Displays helpful tips with an info icon

const AdvisorTip = ({ content }) => {
  return (
    <Box
      style={{
        background: "white",
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        padding: "1rem",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
        transition: "all 0.3s ease",
        cursor: "default",
      }}
      className="advisor-tip"
    >
      <Flex gap="gap.small" vAlign="center">
        <Box
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            background: "#EBF5FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <InfoIcon size="medium" style={{ color: "#3B82F6" }} />
        </Box>
        <Text
          content={content}
          title={content}
          styles={{
            fontSize: "14px",
            color: "#4B5563",
            lineHeight: "1.4",
            "-webkit-line-clamp": 2,
            overflow: "hidden",
            display: "-webkit-box",
            "-webkit-box-orient": "vertical",
            textAlign: "start",
          }}
        />
      </Flex>
    </Box>
  );
};

export default AdvisorTip;
